import React, { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';

import { Dispatch } from '../../../../../store';
import { guids, paths } from '../../../../Root/paths';

import DrawerAction from '../../../../../components/Drawer/DrawerAction';
import DrawerContent from '../../../../../components_/Drawer/DrawerContent';

import Form from './Form';
import Show from './Show';
import PrivateRoute from '../../../../Root/PrivateRoute';

const mapDispatch = (dispatch: any) => {
  const d = dispatch as Dispatch;

  return {
    resetUser: d.infrastructureUsers.resetUser,
    resetFocus: d.infrastructureMap.resetFocus
  };
};

type connectedProps = ReturnType<typeof mapDispatch>;

type IProps = connectedProps;

const User: FC<IProps> = ({ resetUser, resetFocus }) => {
  useEffect(() => {
    return () => {
      resetUser();
    };
  }, []);

  return (
    <>
      <DrawerAction toUrl={paths.map.office.users.root} onClose={resetFocus} />
      <DrawerContent>
        <Switch>
          {/*<Route path={paths.map.office.users.edit()} component={Form} />*/}
          <PrivateRoute
            requirement={{
              uid: guids.map.office.users.edit()
            }}
            path={paths.map.office.users.edit()}
            component={Form}
          />
          {/*<Route path={paths.map.office.users.show()} component={Show} />*/}
          <PrivateRoute
            requirement={{
              uid: guids.map.office.users.show()
            }}
            path={paths.map.office.users.show()}
            component={Show}
          />
        </Switch>
      </DrawerContent>
    </>
  );
};

const withConnect = connect(null, mapDispatch);

export default withConnect(User);
